import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  componentName: string;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ComponentErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error(`🚨 ComponentErrorBoundary [${this.props.componentName}]: Erro detectado:`, {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      componentName: this.props.componentName
    });
  }

  render() {
    if (this.state.hasError) {
      console.error(`🚨 ComponentErrorBoundary [${this.props.componentName}]: Renderizando fallback`);
      return (
        <div className="bg-red-50 border border-red-200 rounded p-4 m-2">
          <h3 className="text-red-800 font-semibold">Erro no componente: {this.props.componentName}</h3>
          <p className="text-red-600 text-sm mt-1">
            {this.state.error?.message || 'Erro desconhecido'}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ComponentErrorBoundary;